import { actionCreatorFactory } from 'typescript-fsa'

const actionCreator = actionCreatorFactory()

export const setSearchTerm = actionCreator<string | undefined>('FILTER_TERM')
